type OsType = 'mac' | 'windows';

/**
 * user agent를 바탕으로 os(윈도우/맥) 반환
 * @returns
 */
export default function getOs(): OsType {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('win') > -1) {
    return 'windows';
  }

  return 'mac';
}
